import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const Platform = ({ roles }) => {

    return (
        <M_Table entityName={'Platform'} filtersOnTable rolePermissions={roles} />
    )
}